module.exports = __webpack_public_path__ + "img/default copy.a7b45b12.jpg";